/* Renis Wollshop — custom wishlist (no app, per user's decision).
   Persisted as an array of product handles in localStorage. This is *per-browser*, not synced
   across devices for logged-in customers: writing to a customer metafield from storefront JS
   isn't possible without a backend (app proxy / Function), which was explicitly out of scope
   ("selbst bauen, kostenlos"). If cross-device sync becomes a requirement later, that needs a
   small server endpoint — flagging here rather than faking it.
   Ported behaviour from _importClaudeDesign/shop/shop-app.jsx (toggleWish / isWished / toasts). */
(function () {
  'use strict';
  var KEY = 'rw_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    updateCountBadges(list.length);
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    var added;
    if (i === -1) { list.push(handle); added = true; } else { list.splice(i, 1); added = false; }
    write(list);
    return added;
  }
  function updateCountBadges(count) {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }
  function applyButtonState(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = on ? btn.dataset.labelRemove : btn.dataset.labelAdd;
    if (!label) return;
    btn.setAttribute('aria-label', label);
    var span = btn.querySelector('[data-wish-label]');
    if (span) span.textContent = label;
  }
  function syncButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      applyButtonState(btn, has(btn.dataset.productHandle));
    });
  }

  window.RWWishlist = { get: read, has: has, toggle: toggle };

  document.addEventListener('DOMContentLoaded', function () {
    syncButtons(document);
    updateCountBadges(read().length);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.dataset.productHandle;
    var title = btn.dataset.productTitle || '';
    var added = toggle(handle);
    document.querySelectorAll('[data-wishlist-toggle][data-product-handle="' + handle + '"]').forEach(function (b) {
      applyButtonState(b, added);
      b.classList.add('rw-heart-pop');
      setTimeout(function () { b.classList.remove('rw-heart-pop'); }, 280);
    });
    if (window.RWToast) {
      window.RWToast(added
        ? { scheme: 'positive', title: 'Zur Wunschliste hinzugefügt', description: title }
        : { scheme: 'neutral', title: 'Von Wunschliste entfernt', description: title });
    }
    if (window.location.pathname.indexOf('/pages/wunschliste') === 0 && !added) {
      var card = btn.closest('[data-product-card]');
      if (card) card.remove();
    }
  });

  // Wishlist page: render cards client-side from the stored handles via Shopify's public
  // product JSON endpoint (/products/<handle>.js) — no app/backend needed.
  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var handles = read();
    if (!handles.length) {
      grid.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = '';
    handles.forEach(function (handle) {
      fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error('not found'); return r.json(); })
        .then(function (p) { grid.appendChild(buildCard(p)); })
        .catch(function () { toggle(handle); }); // product removed/unpublished — drop stale entry
    });
  }

  function money(cents) {
    return 'CHF ' + (cents / 100).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function buildCard(p) {
    var a = document.createElement('div');
    a.className = 'rw-pcard';
    a.setAttribute('data-product-card', '');
    var img = p.featured_image ? p.featured_image.replace(/\.(\w{2,4})(\?.*)?$/, '_600x600_crop_center.$1$2') : '';
    a.innerHTML =
      '<a href="' + p.url + '" style="position:relative; display:block;">' +
      '<div class="rw-pcard-img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
      '</a>' +
      '<button type="button" class="rw-icon-btn rw-icon-btn--sm rw-icon-btn--outline rw-wish-btn" style="position:absolute; top:10px; right:10px;" data-wishlist-toggle data-product-handle="' + p.handle + '" data-product-title="' + p.title.replace(/"/g, '&quot;') + '" aria-pressed="true" aria-label="Von Wunschliste entfernen"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></button>' +
      '<div style="padding:12px 12px 14px; display:flex; flex-direction:column; gap:6px;">' +
      '<a href="' + p.url + '" class="rw-subheading-sm" style="font-weight:500;">' + p.title + '</a>' +
      '<span class="rw-price"><span class="rw-price__amount">' + money(p.price) + '</span></span>' +
      '</div>';
    return a;
  }

  document.addEventListener('DOMContentLoaded', renderWishlistPage);
})();
